export default __webpack_public_path__ + "empty-groups-md.01b627ea.svg";